import { render } from "./CustomerInformation.vue?vue&type=template&id=4c51bfca&scoped=true"
import script from "./CustomerInformation.vue?vue&type=script&lang=js"
export * from "./CustomerInformation.vue?vue&type=script&lang=js"

import "./CustomerInformation.vue?vue&type=style&index=0&id=4c51bfca&scoped=true&lang=css"

import exportComponent from "E:\\GCM3\\Demo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c51bfca"]])

export default __exports__